const prefix = 'drivex/subscription';

export const LOAD_SUBSCRIPTIONS_SUCCESS = `${prefix}/LOAD_SUBSCRIPTIONS_SUCCESS`;
export const LOAD_ACTIVE_SUBSCRIPTION_SUCCESS = `${prefix}/LOAD_ACTIVE_SUBSCRIPTION_SUCCESS`;
